const state = { 
    actionForm:{},
    activeChild: null,
    copyChild:null,
    activeChildAction: null
};
var getters = { 
  actionForm : ( _state) =>{return _state.actionForm },
  activeChild: ( _state) =>{return _state.activeChild },
  copyChild: ( _state) =>{return _state.copyChild },
  activeChildAction: ( _state) =>{return _state.activeChildAction }
};
var mutations = { 
  set_actionForm: (_state, newValue) => { _state.actionForm = newValue },
  set_activeChild: (_state, newValue) => { _state.activeChild = newValue },
  set_copyChild: (_state, newValue) => { _state.copyChild = newValue },
  set_activeChildAction: (_state, newValue) => { _state.activeChildAction = newValue }
};
var actions = { 
  set_actionForm:  (ctx, newValue) => {ctx.commit('set_actionForm', newValue) }, 
  set_activeChild:  (ctx, newValue) => {ctx.commit('set_activeChild', newValue) },
  set_copyChild:  (ctx, newValue) => {ctx.commit('set_copyChild', newValue) },
  set_activeChildAction:  (ctx, newValue) => {ctx.commit('set_activeChildAction', newValue) }
};

const config = {
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
}

export default config;